import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { useDispatch, useSelector } from "react-redux";
import { attendingAppointment, setAttendingAppointment } from "../../../features/CaptureDetailsSlice";
import { useState } from "react";

const RadioGroupControl = (props: any) => {
  const dispatch = useDispatch();
  const isAttending = useSelector(attendingAppointment);

  const [attending, setAttending] = useState(isAttending ? "yes" : "no");

  function handleChange(event: any) {
    const value = event?.target.value;
    setAttending(value);
    dispatch(setAttendingAppointment(value === "yes" ? true : false));
  }

  return (
    <FormControl
      sx={{ w: 1, flexDirection: "row", alignItems: "center" }}
      disabled={props.attending ? true : false}
    >
      <FormLabel id="attending-appointment">
        Will the {props.inputProps.wording} attend the appointment?
      </FormLabel>
      <RadioGroup
        row
        aria-labelledby="attending-appointment"
        name="attending-appointment"
        value={props.attending ?? attending}
        onChange={handleChange}
      >
        <FormControlLabel
          labelPlacement="start"
          value="yes"
          control={<Radio />}
          label="Yes"
        />
        <FormControlLabel
          labelPlacement="start"
          value="no"
          control={<Radio />}
          label="No"
        />
      </RadioGroup>
    </FormControl>
  );
};

export default RadioGroupControl;
